module.exports = __webpack_public_path__ + "static/viewer-a2e5b0ecc2646e8ff7e3191fc5393b25.gif";